import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {LanguageSwitcherSection} from '../../services/language/language-switcher/language-switcher-section';
import {LanguageSwitcherDropdownBox} from "./boxes/language-switcher-dropdown.box";
import {LanguageSwitcherSectionComponent} from './language-switcher-section/language-switcher-section.component';
import {CyClass} from '../../../common/cy-classes';
import {DividerBox} from '../../basic-ui-components/layout/divider/divider.box';

export interface ILanguageSwitcherDropdownProps {
  isOpen: boolean;
}

export const LanguageSwitcherDropdownComponent = observer(
  class LanguageSwitcherDropdownComponent extends OrbitComponent<ILanguageSwitcherDropdownProps> {

    private _renderSection(section: LanguageSwitcherSection) {

      if(section.items.length === 0) {
        return null;
      }

      return <LanguageSwitcherSectionComponent section={section}/>;
    }

    render() {

      let languageSwitcher = this.services.language.languageSwitcher;

      if (languageSwitcher.isEmpty) {
        return null;
      }

      return (
        <LanguageSwitcherDropdownBox isOpen={this.props.isOpen} className={CyClass('cy-language-switcher-dropdown')}>
          {this._renderSection(languageSwitcher.languagesSection)}
          {(this.services.mediaQuery.lAndAbove && languageSwitcher.languagesSection.items.length && languageSwitcher.countriesSection.items.length) ?
            <DividerBox marginTop='1rem' marginBottom='1rem' className="cy-language-switcher-separator" />
          : null}
          {this._renderSection(languageSwitcher.countriesSection)}
        </LanguageSwitcherDropdownBox>
      );
    }
  }
);
